import { INTERNAL_MESSAGE_ALLOWED_SOURCES } from '../constants';

export const isInternalMessageSource = (value: unknown) =>
  typeof value === 'string' && INTERNAL_MESSAGE_ALLOWED_SOURCES.includes(value);
